import { render, staticRenderFns } from "./TopPage.vue?vue&type=template&id=b0e3b174&scoped=true&"
import script from "./TopPage.vue?vue&type=script&lang=ts&"
export * from "./TopPage.vue?vue&type=script&lang=ts&"
import style0 from "./TopPage.vue?vue&type=style&index=0&id=b0e3b174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e3b174",
  null
  
)

export default component.exports